'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import Navigator from '../../Navigator';
import MainNav from '../DashboardNew/Menu/MainNav';
import AdminTemplatesView from './AdminTemplatesView';
import AdminSiteConfigView from './AdminSiteConfigView';
import AdminUsersView from './AdminUsersView';
import AdminInviteUser from './AdminInviteUser';
import AdminFindActivity from './AdminFindActivity';
import AdminOrganizationView from './AdminOrganizationView';
import AdminSubscriptionPlansView from './AdminSubscriptionPlansView';
import AdminOverView from './AdminOverView';
import AdminLtiAssignmentsView from './AdminLtiAssignmentsView';
import AdminRegistrationTokenView from './reg_token_view';
import AdminAnalyticsErrorsView from './AdminAnalyticsErrorsView';
import AdminSendScoreErrorsView from './AdminSendScoreErrorsView';
import AdminStudentFeedbackView from './AdminStudentFeedbackView';
import AdminTemplateBoilerplate from './AdminTemplateBoilerplate';
import AdminTemplatePlaybooks from './AdminTemplatePlaybooks';
import AdminFeaturedDemosView from './AdminFeaturedDemosView';

const propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            viewToken: PropTypes.oneOf([
                'overview',
                'site_config',
                'templates',
                'users',
                'invite',
                'find_activity',
                'orgs',
                'assignments_lti',
                'reg_tokens',
                'subscription_plans',
                'analytics_errors',
                'sendscore_errors',
                'student_feedback',
                'template_ai_playbooks',
                'template_ai_boilerplate',
                'featured_demos'
            ])
        }).isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
};
const defaultProps = {};

const VIEWS = {
    "overview": {
        eventKey: "overview",
        displayName: "Overview",
        component: AdminOverView,
    },
    "site_config": {
        eventKey: "site_config",
        displayName: "Site Config",
        component: AdminSiteConfigView,
    },
    "templates": {
        eventKey: "templates",
        displayName: "Templates",
        component: AdminTemplatesView,
    },
    "users": {
        eventKey: "users",
        displayName: "Users",
        component: AdminUsersView,
    },
    "invite": {
        eventKey: "invite",
        displayName: "Invite User",
        component: AdminInviteUser,
    },
    "find_activity": {
        eventKey: "find_activity",
        displayName: "Find Activity",
        component: AdminFindActivity,
    },
    "orgs": {
        eventKey: "orgs",
        displayName: "Organizations",
        component: AdminOrganizationView,
    },
    "assignments_lti": {
        eventKey: "assignments_lti",
        displayName: "LTI Assignments",
        component: AdminLtiAssignmentsView,
    },
    "reg_tokens": {
        eventKey: "reg_tokens",
        displayName: "Reg. Tokens",
        component: AdminRegistrationTokenView,
    },
    "subscription_plans": {
        eventKey: "subscription_plans",
        displayName: "Subscription Plans",
        component: AdminSubscriptionPlansView,
    },
    "analytics_errors": {
        eventKey: "analytics_errors",
        displayName: "Analytics Errors",
        component: AdminAnalyticsErrorsView,
    },
    "sendscore_errors": {
        eventKey: "sendscore_errors",
        displayName: "Send Score Errors",
        component: AdminSendScoreErrorsView,
    },
    "student_feedback": {
        eventKey: "student_feedback",
        displayName: "Student Feedback",
        component: AdminStudentFeedbackView,
    },
    "template_ai_playbooks": {
        eventKey: "template_ai_playbooks",
        displayName: "Playbooks",
        component: AdminTemplatePlaybooks,
    },
    "template_ai_boilerplate": {
        eventKey: "template_ai_boilerplate",
        displayName: "Boilerplate",
        component: AdminTemplateBoilerplate,
    },

    "featured_demos": {
        eventKey: "featured_demos",
        displayName: "Featured Demos",
        component: AdminFeaturedDemosView,
    },
};

class AdminView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this._onSelectTab = this._onSelectTab.bind(this);
    }

    _onSelectTab(key) {
        this.props.history.push(`/admin/settings/${key}`);
    }

    render() {
        let Component;
        if (!this.props.match.params.viewToken || this.props.match.params.viewToken === 'overview') {
            Component = AdminOverView;
        }
        else {
            Component = VIEWS[this.props.match.params.viewToken].component;
        }
        
        return (
            <div className="admin-page">
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardHome(this.props.history)}
                />
                <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse>
                        <Nav
                            justify
                            variant="tabs"
                            role="tablist"
                            defaultActiveKey="overview"
                            activeKey={this.props.match.params.viewToken}
                            onSelect={(selectedKey) => this.props.history.push(`/admin/settings/${selectedKey}`)}
                        >
                            {Object.values(VIEWS).map((view) => (
                                <Nav.Link key={view.eventKey} eventKey={view.eventKey}>
                                    {view.displayName}
                                </Nav.Link>
                            ))}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <div className="container-fluid padding-lr-xl margin-top-xl" role="tabpanel" aria-expanded="true">
                    <Component history={this.props.history}/>
                </div>
            </div>
        );
    }
}

AdminView.propTypes = propTypes;
AdminView.defaultProps = defaultProps;

export default withRouter(AdminView);